module.exports = __webpack_public_path__ + "edfa307c6882d69afb3181e9caea865a.png";